import React from "react";
import Picture from "../img/picture.jpg";
import { motion } from "framer-motion";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";

const Info = () => {
  return (
    <motion.div
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
      className="info"
    >
      <div className="instructor">
        <div className="contents">
          <h1>
            <span>關於我</span>
          </h1>
          <p>目前有超過五年的程式教學經驗，喜歡與更多人分享我的熱情和知識。</p>
          <p>
            我相信，透過清楚的講解與示範，任何人都可以學好編寫程式與電腦科學中的複雜概念。我透過錄製課程來實現我的理想。目前我有十一堂課程，分別為「AI
            人工智能：深度學習 從原理到實作」、「AI 人工智能：機器學習
            理論到應用」、「2026 Python全攻略」、「2026 網頁開發」、「2026
            Java課程」、「Android開發全攻略」、「2022網頁全端攻略」、「離散數學」、「數論與密碼學」、「資料結構與演算法」，以及「線性代數」。
          </p>
          <p>
            我曾就讀於美國楊百翰大學夏威夷分校，主修讀電腦科學，以及在楊百翰大學拿到電腦科學碩士學位。在到美國之前，完全沒有寫過程式的經驗。在眾多不同的主修當中，我選擇電腦科學(台灣的資訊工程系)來當作主修，因為我從小就對電腦有濃厚的興趣。在此之後，我在軟體工程師的路上越走越遠。目前主要的工作內容是大型系統的維護與開發，以及雲端運算服務的數據分析與處理。
          </p>
        </div>
      </div>
      <div className="instructor">
        <div className="contents">
          <h1>
            <span>聯絡方式</span>
          </h1>
          <p>歡迎用以下方式聯絡我:</p>
          <p>電子郵件信箱:</p>
          <p>
            Email: <span>s9208892088@gmail.com</span>
          </p>
          <p>或是使用:</p>
          <form name="contact" method="POST" action="/contact">
            <input type="hidden" name="form-name" value="contact" />
            <h3>表單</h3>

            <div>
              <label htmlFor="email">信箱:</label>
              <input
                placeholder="你的E-mail"
                id="email"
                name="name"
                type="email"
              />
            </div>
            <div>
              <label htmlFor="con">內容:</label>
              <textarea
                id="con"
                required
                name="texts"
                placeholder="若優惠券已過期，有需要的話，也可以透過此表單聯絡我:) 另外，如果你在上方的信箱填錯的話，會無法收到我的回覆，所以請務必確認填寫的信箱是正確的喔！"
              ></textarea>
            </div>
            <button type="submit">提交表單</button>
          </form>
        </div>
      </div>
      <div className="instructor">
        <div className="contents">
          <h1>特別感謝</h1>
          <p>All the pictures are from this link here:</p>
          <p>
            <a href="https://storyset.com/event">
              <span>Illustration by Freepik Storyset</span>
            </a>
          </p>
          <p>
            Feel free to take a look into their website. They provide various
            options of svg or png images. You can animate the image if you want.
            It's also free to use their stories as part of your project, as you
            remember to contribute the credits to them.
          </p>
        </div>
      </div>
      <ScrollTop />
    </motion.div>
  );
};

export default Info;
